export default __webpack_public_path__ + "cb024176cb652a4d4d91bf5740f17dc6.webp";